var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import JetButton from "@/Jetstream/Button";
import BillingPortalLayout from "../BillingPortalLayout";
import BillingDetailFields from "@/Pages/Teams/Partials/BillingDetailFields";
import useForm from "@/Utils/useForm";
import classNames from "classnames";
import { useRoute } from 'ziggy-js';
import { Ziggy } from '@/ziggy.js';
export default function Index(_a) {
    var team = _a.team;
    var route = useRoute(Ziggy);
    var form = useForm({
        num_credits: "",
        business_name: team.business_name,
        business_address_data: team.business_address_data,
        business_vat: team.business_vat,
    });
    return _jsxs(BillingPortalLayout, { children: [_jsx("h2", __assign({ className: "font-semibold text-xl text-gray-800 leading-tight mb-6" }, { children: "Billing details" })), _jsx("div", __assign({ className: "w-full sm:px-6 lg:px-8" }, { children: _jsx("div", __assign({ className: "-my-2 sm:-mx-6 lg:-mx-8 overflow-x-auto" }, { children: _jsx("div", __assign({ className: "py-2 align-middle inline-block min-w-full" }, { children: _jsx("div", __assign({ className: "" }, { children: _jsxs("div", __assign({ className: "space-y-6 w-3/4" }, { children: [_jsx(BillingDetailFields, { form: form }), _jsx("div", { children: _jsx(JetButton, __assign({ onClick: function () { return form.post(route('billing-portal.updateDetails')); }, className: classNames({ 'opacity-25': form.processing }), disabled: form.processing }, { children: "Save" })) })] })) })) })) })) }))] });
}
